export default __webpack_public_path__ + "static/media/Linkedin Learning JavaScript Essential Training 2020.fd4bc9cd.webp";